import Button from "react-bootstrap/Button";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import { GoBriefcase } from "react-icons/go";
import { FiUser } from "react-icons/fi";
import { RiCustomerService2Line } from "react-icons/ri";
import { RiLoginCircleLine } from "react-icons/ri";
import { RiCloseLargeLine } from "react-icons/ri";
import { IoMdMenu } from "react-icons/io";
import Nav from "react-bootstrap/Nav";
import React, { useEffect, useState } from "react";
import NavDropdown from "react-bootstrap/NavDropdown";
import { AppRoute } from "../../router/routerConstants";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { CiUser } from "react-icons/ci";
import { MdOutlineLogout } from "react-icons/md";
import { Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { logOut } from "../../store/auth.store";
import { clearAllStorage } from "../../utils/Common";
import { clearNotifications } from "../../store/notification.store";
import { clearChatData } from "../../store/chat.store";
import { clearAllResumes, clearResumeDetails } from "../../store/resume.store";

//import { globalContentsApi } from "../../service/apis/globalcontents.api";

const HeaderScreen = () => {
  const [showWork, setShowWork] = useState(false);
  const handleCloseWK = () => setShowWork(false);

  const handleShowWK = () => setShowWork(true);
  const location = useLocation(); // Tracks the current route

  const { sitelogo } = useSelector((state: RootState) => {
    return state.globalDataSlice.Global;
  });
  const { user } = useSelector((state: RootState) => {
    return state.authSlice;
  });
  const [NavigateTo] = useCustomNavigate();

  const [isActive, setActive] = useState(false); // Use a boolean instead of a string
  const ToggleClass = () => {
    setActive(!isActive);
  };

  const navigatee = useNavigate();
  const dispatch = useDispatch();

  const handleNavigation = (event: any, path: any) => {
    event.preventDefault();
    navigatee(path);
  };

  // const lctn = useLocation();
  //const isActivee = (path: any) => lctn.pathname === path ? 'active' : '';

  const isActivee = (path: string, isParent: boolean = false): string => {
    const currentPath: string = window.location.pathname;

    if (isParent) {
      // Mark as active only if currentPath matches exactly the parent path
      return currentPath === path ? "active" : "";
    }

    // For child items, mark as active only if currentPath matches the exact path
    return currentPath === path ? "active" : "";
  };

  const handleNavigateAccount = () => {
    if (user && user?.role === "jobseeker") {
      NavigateTo(AppRoute.JOBSEEKER_DASHBOARD);
    } else if (user && user?.role === "localagents") {
      NavigateTo(AppRoute.AGENT_DASHBOARD);
    } else if (user && user?.role === "employer") {
      NavigateTo(AppRoute.EMPLOYER_DASHBOARD);
    }
  };

  const logoutAction = () => {
    dispatch(logOut());
    clearAllStorage();
    handleCloseWK();
    dispatch(clearResumeDetails());
    dispatch(clearAllResumes());
    dispatch(clearNotifications());
    dispatch(clearChatData());
  };
  //console.log("Header called");
  useEffect(() => {
    setActive(false); // Call function on component change
  }, [location.pathname]);
  return (
    <>
      <header className="mainHeader common-padd-lt-rt common-padd-small pb-0">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className={isActive ? "menuActive" : ""}>
                <div className="mainHeader-holder">
                  <div className="logo text-left">
                    {/* <a onClick={() => NavigateTo(AppRoute.SPLASH)}>
                      <img src={sitelogo} alt="logo" />
                    </a> */}
                    <Link to="/">
                      <img src={sitelogo} alt="logo" />
                    </Link>
                  </div>
                  <div className="navholder">
                    <Nav as="ul">
                      <Nav.Item as="li" className={isActivee("/about")}>
                        <Nav.Link
                          eventKey="link-1"
                          onClick={(e) => handleNavigation(e, "/about")}
                        >
                          About Us
                        </Nav.Link>
                      </Nav.Item>
                      {/* <NavDropdown as="li" title="Our Services" id="basic-nav-dropdown" className={isActivee('/services', true)}> */}
                      <NavDropdown
                        as="li"
                        title="Our Services"
                        id="basic-nav-dropdown"
                      >
                        <NavDropdown.Item as="li">
                          {" "}
                          <Nav.Link
                            eventKey="link-4"
                            onClick={(e) => handleNavigation(e, "/services")}
                          >
                            Our Services
                          </Nav.Link>
                        </NavDropdown.Item>
                        {/* <NavDropdown.Item as="li">
                          <Nav.Link
                            eventKey="link-3"
                            onClick={(e) =>
                              handleNavigation(e, "/our-recruitment-services")
                            }
                          >
                            Our Recruitment Services
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <Nav.Link
                            eventKey="link-4"
                            onClick={(e) =>
                              handleNavigation(e, "/our-immigration-services")
                            }
                          >
                            Our Immigration Services
                          </Nav.Link>
                        </NavDropdown.Item> */}
                        
                        <NavDropdown.Item as="li">
                          <Nav.Link
                            eventKey="link-5"
                            onClick={(e) => handleNavigation(e, "/jobseeker")}
                            title={`Job Seeker`}
                          >
                            Job Seeker
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <Nav.Link
                            eventKey="link-6"
                            onClick={(e) => handleNavigation(e, "/employer")}
                            title={`Employer`}
                          >
                            Employer
                          </Nav.Link>
                        </NavDropdown.Item>
                        <NavDropdown.Item as="li">
                          <Nav.Link
                            eventKey="link-7"
                            onClick={(e) => handleNavigation(e, "/local-agency")}
                            title={`Local Agency`}
                          >
                            Local Agency
                          </Nav.Link>
                        </NavDropdown.Item>
                      </NavDropdown>
                      <Nav.Item as="li" className={isActivee("/job-listing")}>
                        <Nav.Link
                          eventKey="link-8"
                          onClick={(e) => handleNavigation(e, "/job-listing")}
                        >
                          Jobs
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className={isActivee("/blog")}>
                        <Nav.Link
                          eventKey="link-9"
                          onClick={(e) => handleNavigation(e, "/blog")}
                        >
                          Blog
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className={isActivee("/faq")}>
                        <Nav.Link
                          eventKey="link-10"
                          onClick={(e) => handleNavigation(e, "/faq")}
                        >
                          FAQ's
                        </Nav.Link>
                      </Nav.Item>
                      <Nav.Item as="li" className={isActivee("/contact-us")}>
                        <Nav.Link
                          eventKey="link-11"
                          onClick={(e) => handleNavigation(e, "/contact-us")}
                        >
                          Contact Us
                        </Nav.Link>
                      </Nav.Item>
                    </Nav>
                  </div>
                  <div className="hdrbtnholder">
                    {user && user?.isEmailVerified ? (
                      <>
                        <Button
                          className="btn btn-black empbtn"
                          type="button"
                          onClick={() => handleNavigateAccount()}
                        >
                          {" "}
                          <CiUser /> Dashboard
                        </Button>
                        <Button
                          className="btn logout"
                          type="button"
                          onClick={handleShowWK}
                        >
                          {" "}
                          <MdOutlineLogout /> Log Out
                        </Button>
                      </>
                    ) : (
                      <>
                        <Button
                          className="btn btn-black empbtn"
                          type="button"
                          onClick={() => NavigateTo(AppRoute.EMPLOYEE_REGISTER)}
                          title={`Employer`}
                        >
                          {" "}
                          <GoBriefcase /> Employer
                        </Button>
                        <Button
                          className="btn btn-black jobsbtn"
                          type="button"
                          onClick={() =>
                            NavigateTo(AppRoute.JOBSEEKER_REGISTER)
                          }
                          title={`Job Seeker`}
                        >
                          {" "}
                          <FiUser /> Job Seeker
                        </Button>
                        <Button
                          className="btn btn-black agentbtn"
                          type="button"
                          onClick={() => NavigateTo(AppRoute.AGENT_REGISTER)}
                          title={`Local Agency`}
                        >
                          {" "}
                          <RiCustomerService2Line /> Local Agency
                        </Button>
                        <Button
                          className="btn login"
                          type="button"
                          onClick={() => NavigateTo(AppRoute.LOGIN)}
                          title={`Log In`}
                        >
                          <RiLoginCircleLine /> Log In
                        </Button>
                        <button onClick={ToggleClass} className="menuToggle">
                          <IoMdMenu className="linem" />{" "}
                          <RiCloseLargeLine className="menuC" />
                        </button>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Log Out model*/}
      <Modal
        show={showWork}
        onHide={handleCloseWK}
        animation={false}
        aria-labelledby="contained-modal-title-vcenter"
        className="editPersonalInformation"
        centered
      >
        <Modal.Body>
          <div className="findbody text-center">
            <Form className="logoutmdl">
              <div className="logouticon">
                <MdOutlineLogout />
              </div>
              <h3>Log Out</h3>
              <p>Are you sure you want to log out?</p>
              <p>
                You will need to log in again to access your account and view
                your job applications, notifications, and profile.
              </p>
              <div className="d-flex gp-10">
                <Button
                  className="btn btn-black w-100"
                  type="button"
                  onClick={handleCloseWK}
                >
                  Cancel
                </Button>
                <Button
                  className="btn w-100"
                  type="button"
                  onClick={logoutAction}
                >
                  Log Out
                </Button>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
      {/* Log Out model*/}
    </>
  );
};
export default HeaderScreen;
